import{t as e}from"./toPropertyKey-5e4b3a1a.js";function r(r,t,a){return(t=e(t))in r?Object.defineProperty(r,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):r[t]=a,r}export{r as _};
//# sourceMappingURL=defineProperty-0fd9bfdc.js.map
